import React from 'react';

interface ILayoutLogin {
    children?: React.ReactNode;
}

const LayoutLogin = ({ children }: ILayoutLogin) => {
    return (
        <div className='min-h-screen min-w-full flex flex-col bg-white'>
            {/* logo top-left */}
            <header className='w-full px-10 pt-6'>
                <img
                    className='h-14 object-contain'
                    alt='hotelworldAI'
                    src='/assets/auth/hotelworld-ai.svg'
                />
            </header>

            {/* main area with background */}
            <main
                className='
          relative flex-1 flex 
          items-start md:items-center 
          justify-center 
          bg-no-repeat bg-center
          pt-8 md:pt-0
        '
                style={{
                    backgroundImage: "url('/assets/auth/login-back.svg')",
                    backgroundSize: 'contain',
                }}
            >
                <div className='relative z-10 w-full max-w-md px-6 pb-10'>
                    {children}
                </div>
            </main>

            {/* footer */}
            <footer className='w-full px-6 pb-4 flex items-center justify-between text-xs text-gray-500'>
                <div className='flex items-center space-x-2'>
                    <a href='/terms' className='hover:underline'>
                        Terms
                    </a>
                    <span>•</span>
                    <a href='/privacy' className='hover:underline'>
                        Privacy Policy
                    </a>
                </div>
                <span>© All rights reserved.</span>
            </footer>
        </div>
    );
};

export default LayoutLogin;
